/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		// QA #15: if this rail was preserved across a cart-drawer re-render it is
		// already populated — skip the refetch so it doesn't flash / disappear.
		if (this.innerHTML.trim().length) {
			this.parent?.classList.add('product-recommendations--full');
			if (OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
				this.parent?.classList.add('active');
			}
			this.classList.add('product-recommendations--loaded');
			return;
		}
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
